export class Controller {

    /** @ngInject */
    constructor() {
    }

    $onInit() {
        const type = this.application.applicationType.slug;

        this.isComputerLoginWithAD = type === 'computer-login';
        this.isComputerLoginWithoutAD = type === 'computer-protection-without-ad';
        this.isCustom = type === 'custom';
        this.isOffice365 = type === 'office-365';

        const context = require.context('./help/templates/');
        this.hasHelp = context.keys().includes(`./${type}.html`);
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/integration-developers/integration-developers.controller.js